export default __webpack_public_path__ + "static/media/user4.305ebe6d.webp";